export const provinces = [
  { code: "MB", name: "Manitoba" },
  { code: "ON", name: "Ontario" },
  { code: "QC", name: "Quebec" },
  { code: "NS", name: "Nova Scotia" },
  { code: "NB", name: "New Brunswick" },
  { code: "BC", name: "British Columbia" },
  { code: "PE", name: "Prince Edward Island" },
  { code: "SK", name: "Saskatchewan" },
  { code: "AB", name: "Alberta" },
  { code: "NL", name: "Newfoundland and Labrador" },
  { code: "NT", name: "Northwest Territories" },
  { code: "YT", name: "Yukon" },
  { code: "NU", name: "Nunavut" },
];

export const provinceOptions = provinces
  .slice()
  .sort((a, b) => a.name.localeCompare(b.name))
  .map((location) => ({
    value: location.code,
    label: `${location.code} - ${location.name}`,
  }));
